module.exports = __webpack_public_path__ + "img/image-not-found.b492c106.png";